import React from "react";

// Filled semantic pills. Orange is reserved for brand/CTA — never used for status.
// info(blue)=neutral in-progress, warning(amber)=needs action, success(green)=done/healthy, neutral(slate)=idle.
const STATUS_TONE = {
  "Quote Requested": "badge-neutral",
  "PO Raised": "badge-info",
  "PO Placed": "badge-info",
  "PO Issued": "badge-info",
  "Supplier PFI Received": "badge-info",
  "Supplier Invoice Received": "badge-info",
  "Delivery Note Received": "badge-info",
  "Payment Due": "badge-warning",
  "Payment Processed": "badge-success",
  "Ready to Invoice": "badge-warning",
  "Invoice Issued to Client": "badge-info",
  "Closed": "badge-success",
};

export function StatusBadge({ status }) {
  const tone = STATUS_TONE[status] || "badge-neutral";
  return (
    <span
      data-testid={`status-badge-${status?.replace(/\s+/g, "-").toLowerCase()}`}
      className={`badge ${tone}`}
    >
      {status}
    </span>
  );
}
